import { Provider } from '@angular/core';
import { MODAL_REGISTRY } from '@features/modals/modal-registry.token';
import { TipRainModalComponent } from '@features/rain/tip-rain-modal/tip-rain-modal.component';

export function provideRainModals(): Provider[] {
  return [
    { provide: MODAL_REGISTRY, useValue: { key: 'TipRainModal', component: TipRainModalComponent, requiresAuth: true }, multi: true },
  ];
}
